import Page from "components/base/Page";

const PageV2 = ({
  title,
  subtitle,
  backTo,
  toolbar,
  containerClassName = "p-6",
  header,
  children,
  footer,
  testing,
  testingMessage,
  leftButtons,
}) => {
  return (
    <Page
      title={title}
      subtitle={subtitle}
      className="h-screen"
      staticHeader
      rightButtons={toolbar}
      backTo={backTo}
      testing={testing}
      testingMessage={testingMessage}
      leftButtons={leftButtons}
    >
      <div
        className={`flex-1 overflow-auto flex flex-col space-y-4 ${containerClassName}`}
      >
        {header}
        {children}
        {footer}
      </div>
    </Page>
  );
};

export default PageV2;
